import React from 'react'
import { Col, Flex, Row, Typography } from 'antd'
import { UnderlineDesign } from '../UnderlineDesign'


const { Title, Text } = Typography
const Ourmission = () => {
  return (
    <div className='padding-t'>
        <div className='container'>
            <Row gutter={[64, 24]} align={'middle'}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <div>
                        <img src="assets/images/mission.jpg" width={'100%'} className='rounded' alt="" />
                    </div>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <Flex vertical gap={20}>
                        <Flex vertical>
                            <Title level={2} className='m-0 gradient-text'>Our Mission</Title>
                            <UnderlineDesign />
                        </Flex>
                        <Text className='fs-16 text-justify'>
                        We are committed to simplifying the way people find and hire experts by offering a reliable platform that promotes quality work, honest communication, and lasting results. Whether it's a home renovation, a commercial build, or a quick repair, we aim to match every client with the right pro for the job—quickly and confidently.
                        </Text>
                    </Flex>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {Ourmission}